import React from 'react';
import AnalyticsDashboard from './analytics/AnalyticsDashboard';

export default function AnalyticsTab() {
  return <AnalyticsDashboard />;
}
